<!--
    file type .....: HTML file: match.component.html
    Created By ....: ianday
    Date ..........: 11/14/23
-->
<div class="match-container">
    <div class="local-top-section">
        <div class="dwform">
            <div class="dwform-row-gap"></div>

            <label class="label-field">Case Information:</label>
            <span class="form-required"> </span>
            <label class="label-field-data">{{this.serviceRequest?.caseNumber}} -
                {{this.serviceRequest?.caseName}}</label>

            <!-- Request Type --->
            <div class="dwform-row-gap"></div>

            <label class="label-field">Request Type:</label>
            <span class="form-required"> </span>
            <label class="label-field-data">{{this.serviceRequest?.serviceRequestDesc}}</label>

            <div class="dwform-row-gap"></div>

            <!-- Current Matched Agency  --->

            <label class="label-field">Assigned Agency:</label>
            <span class="form-required"> </span>
            <label class="label-field-data">{{currentAgency}}</label>

            <div class="dwform-row-gap"></div>

            <!-- Current Matched Zip code:  --->

            <label class="label-field">Zip / County:</label>
            <span class="form-required"> </span>
            <label class="label-field-data">{{this.serviceRequest?.zipCode}}</label>

            <div class="dwform-row-gap"></div>

            <mat-divider></mat-divider>

            <div class="dwform-row-gap"></div>
            <label class="label-field">Choose Agencies:</label>
            <span class="form-required"> </span>

            <div class="dwform-row-gap"></div>
        </div>

        <div class="table-container mat-elevation-z2" (keydown)="tableKeyDown($event)" tabindex="-1">
            <table mat-table [dataSource]="dataSource" style="width:100%; border:none;">

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef
                        class="mat-table-header-style" [hidden]="true"></th>
                    <td mat-cell *matCellDef="let element" class="table-row-class" [hidden]="true"
                        class="width: 6px">
                        {{element.id}} </td>
                </ng-container>

                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef
                        class="mat-table-header-style" style="width: 20px;text-align: center">Chk</th>
                    <td mat-cell *matCellDef="let element;let tableRowIdx = index;"
                        style="width:20px!important;text-align: center;">
                        <mat-checkbox (change)="checkAgency($event, tableRowIdx)" [(ngModel)]="element.select" >
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="agencyName">
                    <th mat-header-cell *matHeaderCellDef
                        class="mat-table-header-style" style="width: 100px"> Agency </th>
                    <td mat-cell *matCellDef="let element" class="table-row-class"
                        style="width: 50%">
                        {{element.agencyName}} </td>
                </ng-container>

                <ng-container matColumnDef="collaborationStatus" >
                    <th mat-header-cell *matHeaderCellDef style="width: 100px"
                        class="mat-table-header-style"> Status </th>
                    <td mat-cell *matCellDef="let element" class="table-row-class"
                        [ngStyle]="{'color': getStatusColors(element.collaborationStatus)}">

                        {{element.collaborationStatus}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                    (click)="onRowClicked(row)">
                </tr>
            </table>
        </div>

        <!-- checkbox for un-match -->
        <div class="dwform-row-gap"></div>
       <!-- <mat-checkbox binary="true"
                      (change)="doUnAssignCheckBoxChange($event)"
                      [(ngModel)]="broadcastFlag"
                      [ngModelOptions]="{standalone: true}">Broadcast this Collaboration Request</mat-checkbox>
        <div class="dwform-row-gap"></div>
        -->
    </div>

    <!----------------------->
    <!-- ERROR LINE --------->
    <!----------------------->
    <div class="error-line" [hidden]='!strErr.length'
         style="text-align:left; bottom:53px; left: 15px;">{{strErr}}</div>
    <!----------------------->
    <!-- SAVE STRIP        -->
    <!----------------------->
    <div style="text-align:center; margin-top: 30px;">
        <button class="command-button"
                [disabled]="!itemSelected"
                (click)="onSubmitClicked()" matTooltip="Submit / save this entry"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Submit
        </button>
        <button class="command-button"
                (click)="onCancelClicked()" matTooltip="Cancel without saving this entry"
                mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>

</div>
